import $ from "jquery";
import DestinationCampaign from './destination_campaign';

export default class VirtualLineMover {
  constructor(config) {
    this.config = config;
    this.id = config.id;
    this.promoNumber = config.promoNumber;
    this.hasCustomData = config.hasCustomData;
    this.moveCustomData = config.hasCustomData;
    this.errors = {};
    this.moveUrl = config.moveUrl;

    const { originalAdvertiserCampaignId, originalAffiliateId } = config;

    this.destinationCampaignConfig = {
      originalAdvertiserCampaignId:     originalAdvertiserCampaignId,
      originalAffiliateId:              originalAffiliateId,
      destinationAdvertiserCampaignUrl: config.destinationAdvertiserCampaignUrl,
      affiliateUrlBase:                 config.affiliateUrlBase
    };

    this.destinationCampaign = new DestinationCampaign(this.destinationCampaignConfig);
    this.validate();
  }

  validate() {
    this.errors = { ...this.destinationCampaign.validate() };
  }

  valid() {
    return Object.keys(this.errors).length === 0;
  }

  errorMessages() {
    const errorStrings = Object.keys(this.errors).map(errorKey => {
      return this.errors[errorKey];
    });

    return errorStrings.join("\n");
  }

  updateDestination(params) {
    this.destinationCampaign = new DestinationCampaign({ ...this.destinationCampaignConfig, ...params });
    this.errors = this.destinationCampaign.validate();
  }

  saveData() {
    return {
      id: this.id,
      move_custom_data: this.moveCustomData,
      ...this.destinationCampaign.saveData()
    };
  }

  save(successCallback, errorCallback) {
    $.ajax({
      url: this.moveUrl,
      method: "POST",
      data: this.saveData(),
      success: (data, status, xhr) => {
        if (xhr.status === 200) {
          this.destinationUrl = data.destination.link;
          this.destinationLabel = data.destination.name;
          successCallback(this);
        } else {
          errorCallback(JSON.parse(data.responseText).errors);
        }
      },
      error: (data, status, xhr) => {
        errorCallback(JSON.parse(data.responseText).errors);
      }
    });
  }
}
